import Helmet from "../Components/Helment";
import { MainLayout } from "../Components/MainLayout";

// const Messages = ()=>{
//   return (<div className="card wd-50  wm-100 mx-auto ">پیام های من</div>)
// }
// export default () =><Helmet title='پیام های من'> <MainLayout children={<Messages />} /></Helmet>;

import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import DataTableTemplate from "../../Cpanel/Components/DataTableTemplate";

// import { fetchData, getFilterButton, getFilterClearButton, getFilterDate } from "../Components/Utilities";
import { useForm } from "react-hook-form";
import { fetchData } from "../../Cpanel/Components/Utilities";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
const Messages = () => {
  const [defaultDatatableRows, setDefaultDatatableRows] = useState(10);
  const [pageData, setPageData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const navigate = useNavigate();
  const [lazyState, setLazyState] = useState({
    first: 0,
    page: 0,
    rows: defaultDatatableRows,
    filters: {
      date: { value: "", matchMode: "contains" },
    },
    sortField: "date",
    sortOrder: 1,
  });
  const defaultValues = {};
  const {
    handleSubmit,
    control,
    reset,
    register,
    setValue,
    watch,
    formState: { errors },
  } = useForm({ defaultValues });
  const [notifications, setNotifications] = useState([
    { id: 1, content: "Notification 1", timestamp: new Date(), read: false },
    { id: 2, content: "Notification 2", timestamp: new Date(), read: true },
    // Add more notifications as needed
  ]);
  const [isRead, setIsRead] = useState(false);

  const toggleRead = (id) => {
    const updatedNotifications = notifications.map((notif) =>
      notif.id === id ? { ...notif, read: !notif.read } : notif
    );
    setNotifications(updatedNotifications);
    setIsRead(true);
  };
  const rowClassName = (rowData) => {
    console.log(rowData)
    return {
      "read-row": rowData.id === 10,
      'unread-row': !rowData.read
    };
  };
  const cols = [
    {
      field: "",
      header: "ردیف",
      body: (data, options) => options.rowIndex + 1,
    },
    // {
    //   field: "basketid",
    //   header: "شناسه سبد خرید",
    // },
    // {
    //   field: "username",
    //   header: "نام خریدار",
    //   body: (data, options) => data?.username?.split("|")[0],
    // },
    // {
    //   field: "date",
    //   header: "تاریخ ",
    //   sortable: true,
    //   filter: true,
    //   filterPlaceholder: "نام را وارد کنید",
    //   showFilterMatchModes: false,
    //   showFilterOperator: false,
    //   filterApply: getFilterButton,
    //   filterElement: (options) =>
    //     // getFilterInputText(options, "نام یا نام خانوادگی را وارد کنید..."),
    //     getFilterDate(options, '', watch, control),
    //   filterClear: getFilterClearButton,
    // },
    {
      field: "date",
      header: "تاریخ",
      sortable: true,
    },
    {
      field: "date",
      header: "زمان",
      body: (data, options) => data?.date?.split("|")[0],
    },
    { field: "description", header: "پیام" },
    {
      field: "status",
      header: "وضعیت",
      body: (rowData) => (
        <button
          className={
            isRead ? "btn btn-disabled btn-secondary" : "btn btn-primary"
          }
          onClick={() => toggleRead(rowData.id)}
        >
          {isRead ? " خوانده شده" : " خوانده  نشده"}
        </button>
      ),
    },
    // {
    //   field: "basketid",
    //   header: "جزئیات",
    //   body: (data, options) => (
    //     <div className="my-1">
    //       <FontAwesomeIcon
    //         icon={"edit"}
    //         onClick={() => handleOpeEditItem(data?.basketid)}
    //         className="icon-sm prime-bg text-white p-1 text-center rounded"
    //         color="gray"
    //       />
    //     </div>
    //   ),
    // },
  ];
  useEffect(() => {
    const bodyFormData = new FormData();
    bodyFormData.append("pageNo", lazyState.page + 1 ?? 1);
    bodyFormData.append("pageSize", lazyState.rows ?? 20);
    fetchData("allbasket", bodyFormData, handleApiResponse);
  }, []);
  const onPage = (event) => {
    setLazyState((cur) => ({ ...cur, ...event }));
    setDefaultDatatableRows(event.rows);
  };
  const handleApiResponse = (data) => {
    setPageData(data?.data);
    setTotalRecords(data?.count);
  };
  const handleSort = (event) => {
    console.log(event);
    const { sortField, sortOrder } = event;
    console.log(sortField, sortOrder);
    setLazyState((prevState) => ({
      ...prevState,
      sortField: sortField,
      sortOrder: sortOrder,
    }));
  };
  const onFilter = (event) => {
    event["first"] = 0;
    setLazyState((cur) => ({ ...cur, ...event }));
  };
  return (
    <div className="container">
      <button
        className=" btn btn-outline-secondary fw-bold d-flex align-items-center gap-2  mb-2"
        onClick={() => navigate(-1)}
      >
        <span>
          {" "}
          <FontAwesomeIcon
            icon={"arrow-right"}
            className="fa-small "
          ></FontAwesomeIcon>{" "}
        </span>
        <span>بازگشت</span>
      </button>
      <div className="card  wm-100 m-auto container">
        <div className="card-body">
          <h5 className="card-title text-center">
            <span className="text-warning">
              <FontAwesomeIcon icon="message" className="header-icon fs4" />
            </span>{" "}
            پیام های من
          </h5>
        </div>
        {/* <DataTableTemplate
          sortOrder={lazyState.sortOrder}
          sortField={lazyState.sortField}
          onSort={handleSort}
          lazyState={lazyState}
          // header={header}
          // select='select'
          className={"table-border"}
          columns={cols}
          list={pageData}
          totalRecords={totalRecords}
          setlazyState={setLazyState}
          filters={lazyState.filters}
          onFilter={onFilter}
          setDefaultDatatableRows={setDefaultDatatableRows}
          defaultDatatableRows={defaultDatatableRows}
          width="25rem"
          // header={header}
        /> */}
        <DataTable
          value={pageData}
          lazy
          totalRecords={totalRecords}
          sortField={lazyState.sortField}
          sortOrder={lazyState.sortOrder}
          onPage={onPage}
          onSort={ handleSort}
          first={lazyState.first}
          rows={lazyState.rows}
          // onPage={(e) => onPage(e)}
          // onPage={(e) => onPage(e)}
          filters={lazyState.filters}
          onFilter={onFilter}
          // onSelectionChange={(e) => setSelectedItems(e.value)}
          className={"table-border"}
          rowClassName={rowClassName} // Add this line
        >
          {cols.map((col, i) => (
            <Column
              key={i}
              field={col.field}
              header={col.header}
              sortable={col.sortable}
              filter={col.filter}
              filterPlaceholder={col.filterPlaceholder}
              showFilterMatchModes={col.showFilterMatchModes}
              showFilterOperator={col.showFilterOperator}
              filterMatchMode={col.filterMatchMode}
              filterApply={col.filterApply}
              filterElement={col.filterElement}
              filterClear={col.filterClear}
              body={col.body}
            />
          ))}
        </DataTable>
      </div>
    </div>
  );
};

export default () => (
  <Helmet title="پیام های من">
    {" "}
    <MainLayout children={<Messages />} />
  </Helmet>
);
